import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import BreadcrumbsCustom from 'src/components/common/BreadcrumbsCustom';
import PaymentList from 'src/components/payments/PaymentList';

const breadcrumbsDefine = [
  {
    to: '/payments',
    label: '会計',
  },
  {
    label: '支払い状況一覧',
  },
];
const Payments = () => {
  return (
    <>
      <BreadcrumbsCustom breadcrumbs={breadcrumbsDefine} />
      <Typography
        fontSize={'20px'}
        fontWeight={500}
        color={'primary.dark'}
        mt={'18px'}
        mb={'16px'}
      >
        支払い状況一覧
      </Typography>
      <Stack direction={'row'} spacing={'20px'} width={'auto'}>
        <PaymentList />
      </Stack>
    </>
  );
};

export default Payments;
